<template>
    <div class="search-form">
        <form
            ref="searchForm"
            class="global-search-form"
            action="/search/"
            method="get"
        >
            <input
                v-model="searchRequest"
                class="text global-search"
                autocomplete="off"
                placeholder="Поиск среди 120 000 товаров"
                name="GlobalFilterForm[namearticle]"
                type="text"
                @input="searchRequest = $event.target.value"
                @keydown.tab.prevent="setHint"
                @keyup.arrow-right="setHint($event)"
                @keydown.arrow-up.self.prevent="setActive('up')"
                @keydown.arrow-down.self.prevent="setActive('down')"
                @keydown.enter.self.prevent="hintSelectedHandle(selectedHint)"
                @focus="setRequest"
            />
            <input
                v-model="searchIndex"
                type="hidden"
                name="GlobalFilterForm[sindex]"
            />
            <div
                class="custom-behavior reset"
                name="yt7"
                value="Очистить"
                @click="clear"
            ></div>
            <button
                ref="submit"
                class="button global-search-button"
                type="submit"
                name="yt8"
                @click.prevent="submitFormHandle"
            >
                Найти
            </button>
        </form>
        <ul v-if="showList" class="autocomplete-list">
            <li v-if="message" class="autocomplete-one">
                <div class="autocomplete-one__title">
                    <div>{{ message }}</div>
                </div>
            </li>
            <li
                v-for="(line, index) in autocompleteTips"
                :key="index"
                :class="[
                    'autocomplete-one',
                    index == activeIndex ? 'active' : '',
                ]"
                @mouseenter="setActive(index)"
                @click="hintSelectedHandle(line)"
            >
                <img :src="line.picUrl" />
                <div>
                    <div class="autocomplete-one__title">
                        <span v-if="line.isCategory">Категория: </span>
                        <div
                            v-html="
                                $options.filters.highlight(
                                    line.name,
                                    searchRequest
                                )
                            "
                        ></div>
                    </div>
                    <div class="autocomplete-one__descr">
                        <span v-if="line.tovCount > 1"
                            >Товаров: {{ line.tovCount }}</span
                        >
                        <span
                            v-if="
                                line.avgPrice &&
                                !line.isCategory &&
                                line.tovCount == 1
                            "
                            >Цена:
                            <div class="autocomplete-one__price">
                                {{ line.avgPrice }}
                            </div></span
                        >
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { eventsSender } from 'globalState/global-state.js';
    import { searchGoal } from 'globalState/goals/';

    export default {
        filters: {
            highlight(words, query) {
                return words.replace(query, function (str) {
                    return '<span class="highlight">' + str + '</span>';
                });
            },
        },
        data() {
            return {
                searchRequest: null,
                openList: false,
                showList: false,
                autocompleteTips: null,
                request: null,
                showHint: false,
                searchIndex: null,
                selectedHint: null,
                activeIndex: null,
                message: null,
            };
        },
        computed: {
            hint() {
                if (this.autocompleteTips != null) {
                    var hintList = [];
                    var reg = new RegExp(this.searchRequest, 'gi');
                    this.autocompleteTips.forEach(function (elem, index) {
                        if (elem.name.search(reg) == 0 && !elem.isCategory) {
                            hintList.push({
                                elem: elem,
                                index: index,
                            });
                        }
                    });
                    if (hintList.length > 0) {
                        return hintList[0].elem;
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            },
            hintText() {
                if (this.hint != null) {
                    return this.hint.name.slice(
                        this.request.length,
                        this.hint.name.length
                    );
                } else {
                    return null;
                }
            },
        },
        watch: {
            searchRequest() {
                var self = this;
                this.showHint = false;
                clearTimeout(window.autocomplete_timeout);
                window.autocomplete_timeout = setTimeout(function () {
                    self.setRequest();
                }, 500);
            },
        },
        mounted() {
            this.$nextTick(function () {
                var self = this;
                $(document).mouseup(function (e) {
                    var container = $(
                        '.autocomplete-list, .global-search, .autocomplete-hint'
                    );

                    if (
                        !container.is(e.target) &&
                        container.has(e.target).length === 0
                    ) {
                        self.showHint = false;
                        self.showList = false;
                        self.request = null;
                    }
                });

                if ($('.search-article').length > 0) {
                    var text = $('.search-article').eq(0).text();
                    this.searchRequest = text;
                    this.request = text;
                }
            });
        },
        methods: {
            hintSelectedHandle(hint) {
                if (!hint) {
                    //** @doc для сценария через ентер, без выбора подсказки */
                    this.submitFormHandle();
                    return;
                }

                if (hint.name) {
                    eventsSender('search', 'prompt', hint.name);
                }

                if (this.showList && hint) {
                    if (hint.isCategory) {
                        this.showList = false;
                        this.showHint = false;
                        this.searchRequest = hint.name;
                        document.location.assign(hint.value);
                    } else {
                        this.showList = false;
                        this.showHint = false;
                        this.searchRequest = hint.name;
                        this.searchIndex = hint.value;
                        this.request = hint.name;
                        this.$nextTick(function () {
                            this.submitFormHandle();
                        });
                    }
                } else {
                    this.submitFormHandle();
                }
            },
            getAutocompleet() {
                var searchRequest = this.searchRequest;
                var self = this;
                $.ajax({
                    type: 'GET',
                    data: {
                        term: searchRequest,
                    },
                    url: '/search/global/',
                    dataType: 'json',
                    success(response) {
                        switch (response.status) {
                            case 'success':
                                self.autocompleteTips = response.data;
                                self.showList = true;
                                self.showHint = true;
                                self.selectedHint = null;
                                self.activeIndex = null;
                                break;
                            case 'fail':
                                if (
                                    response.data !== undefined &&
                                    response.data.length > 0
                                ) {
                                    self.autocompleteTips = response.data;
                                    self.showList = true;
                                    self.showHint = true;
                                    self.selectedHint = null;
                                    self.activeIndex = null;
                                }

                                if (response.message) {
                                    self.message = response.message;
                                } else {
                                    self.message = null;
                                }
                        }
                    },
                });
            },
            setHint(event) {
                if (
                    (this.showHint &&
                        this.hint &&
                        this.hint.name.length > this.searchRequest.length &&
                        event.key == 'Tab') ||
                    this.getPos(event) == this.searchRequest.length
                ) {
                    this.searchIndex = this.hint.value;
                    this.request = this.hint.name;
                    this.searchRequest = this.hint.name;
                    this.showList = false;
                    this.showHint = false;
                }
            },
            setRequest() {
                if (this.searchRequest != null) {
                    if (
                        this.searchRequest.length > 1 &&
                        this.searchRequest != this.request
                    ) {
                        this.getAutocompleet();
                        this.request = this.searchRequest;
                    } else {
                        this.showList = false;
                        this.autocompleteTips = null;
                        this.showHint = false;
                    }
                }
            },
            setActive(direction) {
                if (this.showList) {
                    if (this.selectedHint != null) {
                        switch (direction) {
                            case 'down':
                                this.activeIndex = this.activeIndex + 1;
                                this.selectedHint =
                                    this.autocompleteTips[this.activeIndex];
                                break;
                            case 'up':
                                this.activeIndex = this.activeIndex - 1;
                                this.selectedHint =
                                    this.autocompleteTips[this.activeIndex];
                                break;
                            default:
                                this.activeIndex = direction;
                                this.selectedHint =
                                    this.autocompleteTips[this.activeIndex];
                        }
                    } else {
                        switch (direction) {
                            case 'down':
                                this.selectedHint = this.autocompleteTips[0];
                                this.activeIndex = 0;
                                break;
                            case 'up':
                                var index = this.autocompleteTips.length - 1;
                                this.selectedHint =
                                    this.autocompleteTips[index];
                                this.activeIndex = index;
                                break;
                            default:
                                this.activeIndex = direction;
                                this.selectedHint =
                                    this.autocompleteTips[this.activeIndex];
                        }
                    }
                }
            },
            submitFormHandle() {
                if (!this.selectedHint) {
                    searchGoal.buttonFind(this.searchRequest);
                }

                this.$refs.searchForm.submit();
            },
            getPos(event) {
                var input = event.target;
                var pos = input.selectionStart;
                return pos;
            },
            clear() {
                this.searchRequest = null;
                this.request = null;
            },
        },
    };
</script>
